import { Injectable, EventEmitter } from '@angular/core';

import { HttpService } from 'gast-common-ng';
import { GastRequestModel } from 'gast-common-ng/lib/shared/models/gast-request.model';
import { GastRequestWithBodyModel } from 'gast-common-ng/lib/shared/models/gast-request-with-body.model';
import { BookingDto } from 'src/shared/dtos/booking/booking-dto';
import { BookingMappingDto } from '../dtos/booking-mapping-dto';
import { UrlService } from './common/url.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class OnsetService {
    checkTanCompleted: EventEmitter<Boolean> = new EventEmitter();
    bookingMappingLoaded: EventEmitter<BookingMappingDto> = new EventEmitter();
    bookingMappingSaved: EventEmitter<Array<BookingMappingDto>> = new EventEmitter();
    bookingStudyLoaded: EventEmitter<BookingDto> = new EventEmitter();
    checkIfEnoughMobileParticipantDone: EventEmitter<boolean> = new EventEmitter();

    constructor(
        private httpService: HttpService,
        private http: HttpClient,
        private urlService: UrlService) { }

    createBookingMappingForBooking(bookingDto: BookingDto, username: string): void {
        const callback = (found: Array<BookingMappingDto>) => {
            this.bookingMappingSaved.emit(found);
        };

        const errorCallback = (error: Response) => {
            console.log(' cannot save booking mapping');
        };

        const url = this.urlService.createOnsetBookingForOnsetStudy(username);

        const request = {
            method: 'POST',
            mapper: (response: Response) => <any>response.json(),
            callback: callback,
            body: bookingDto,
            url: url
        } as GastRequestWithBodyModel<any, BookingDto>;
        this.http.post(url, bookingDto, { withCredentials: true, responseType: 'json' })
            .subscribe(callback, errorCallback);
    }

    createOnsetBookingStudy(): void {
        const callback = (found: BookingDto) => {
            this.bookingStudyLoaded.emit(found);
        };

        const errorCallback = (error: Response) => {
            console.log(' cannot create onset booking for study');
        };

        const url = this.urlService.createGastBookingForOnsetStudy();

        const request = {
            method: 'POST',
            mapper: (response: Response) => <any>response.json(),
            callback: callback,
            body: null,
            url: url
        } as GastRequestWithBodyModel<any, BookingDto>;
        this.httpService.post(request, errorCallback);
    }

    checkIfEnoughMobileParticipantForOnsetStudy(): void {
        const successCallback = (result: String) => {
            const booleanValue = result == 'true' ? true : false;
            this.checkIfEnoughMobileParticipantDone.emit(booleanValue);
        };

        const errorCallback = (error: Response) => {
            console.log(error);
        };

        const url = this.urlService.checkIfAlreadyEnoughParticipantForMobileVersion();
        this.http.get(url, { withCredentials: true, responseType: 'text' })
            .subscribe(successCallback, errorCallback);
    }
}
